import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';

import {renderModal} from '../../shared/components/layouts/OldModal';

import {updatePurchaseOrder} from '../../trade_documents/purchaseOrdersActions';

import {updateInvoice} from '../../trade_documents/invoicesActions';

import {
  fetchUserContacts,
  fetchPurchaseOrderContacts,
  fetchInvoiceContacts,
  deleteUserContact,
} from '../contactsActions';

import Empty from '../components/Empty';
import TradeContact from '../components/TradeContact';
import ContactContainerModal from '../components/ContactContainerModal';
import {TrackEventName} from '../../shared/constants/SegmentEvents';

class WholeContactsManagerContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: {},
      trade_document_contacts: this.props.trade_document_contacts || [],
    };
  }

  static defaultProps = {
    trackEvent: name => {},
  };

  componentDidMount() {
    this.props.dispatch(fetchUserContacts(this.props.user_id));
    this.fetchTradeDocumentContacts();
  }

  fetchTradeDocumentContacts = () => {
    this.props.dispatch(
      fetchUserContacts(this.props.user.id, this.props.trade_id),
    );
    if (this.props.trade_type === 'PurchaseOrder') {
      this.props.dispatch(
        fetchPurchaseOrderContacts(this.props.user.id, this.props.trade_id),
      );
    } else if (this.props.trade_type === 'Invoice') {
      this.props.dispatch(
        fetchInvoiceContacts(this.props.user.id, this.props.trade_id),
      );
    }
  };

  shouldResolveNotification = () => {
    return (
      this.props.fca_action &&
      (this.props.fca_action.includes('contact') ||
        this.props.fca_action.includes('not_endorsed_by_buyer'))
    );
  };

  onCloseModal = () => {
    this.props.trackEvent(TrackEventName.MODAL_CLOSE_CLICKED);
  }

  onDeleteContact = (contactId, successCallback, errorCallback) => {
    const eventName =
      this.props.trade_type === "PurchaseOrder"
        ? TrackEventName.PURCHASE_ORDER_CUSTOMER_CONTACT_DELETE_CLICKED
        : TrackEventName.INVOICE_CUSTOMER_CONTACT_DELETE_CLICKED;
    this.props.trackEvent(eventName);
    const onSuccess = () => {
      this.fetchTradeDocumentContacts();
      successCallback();
    };

    this.props.dispatch(
      deleteUserContact(
        {
          userId: this.props.user.id,
          contactId,
        },
        onSuccess,
        errorCallback,
      ),
    );
  };

  onDeleteContactFromList = id => {
    return e => {
      const eventName =
        this.props.trade_type === 'PurchaseOrder'
          ? TrackEventName.PURCHASE_ORDER_CUSTOMER_CONTACT_DELETE_CLICKED
          : TrackEventName.INVOICE_CUSTOMER_CONTACT_DELETE_CLICKED;
      this.props.trackEvent(eventName);

      e.preventDefault();

      if (this.props.trade_type === 'PurchaseOrder') {
        const payload = JSON.stringify({
          purchase_order: {
            buyer_contacts_attributes: [{id: id, _destroy: true}],
          },
        });
        this.props.dispatch(
          updatePurchaseOrder(
            this.props.trade_id,
            this.props.user.id,
            payload,
            this.fetchTradeDocumentContacts,
            true,
          ),
        );
      } else if (this.props.trade_type === 'Invoice') {
        const payload = JSON.stringify({
          invoice: {buyer_contacts_attributes: [{id: id, _destroy: true}]},
        });
        this.props.dispatch(
          updateInvoice(
            this.props.trade_id,
            this.props.user.id,
            payload,
            this.fetchTradeDocumentContacts,
            true,
          ),
        );
      }
    };
  };

  onAddContactToList = () => {
    return tradeContact => {
      if (this.props.trade_type === 'PurchaseOrder') {
        const payload = JSON.stringify({
          purchase_order: {
            buyer_contacts_purchase_orders_attributes: [
              {
                purchase_order_id: this.props.trade_id,
                buyer_contact_id: tradeContact.id,
              },
            ],
          },
        });
        this.props.dispatch(
          updatePurchaseOrder(
            this.props.trade_id,
            this.props.user.id,
            payload,
            this.fetchTradeDocumentContacts,
            true,
          ),
        );
      } else if (this.props.trade_type === 'Invoice') {
        const payload = JSON.stringify({
          invoice: {
            buyer_contacts_invoices_attributes: [
              {
                invoice_id: this.props.trade_id,
                buyer_contact_id: tradeContact.id,
              },
            ],
          },
        });
        this.props.dispatch(
          updateInvoice(
            this.props.trade_id,
            this.props.user.id,
            payload,
            this.fetchTradeDocumentContacts,
            true,
          ),
        );
      }

      if (this.shouldResolveNotification()) {
        this.props.resolveNotifications(this.props.fca_action);
      }
    };
  };

  onCreateContact = (payload, onSuccess, errorCallback) => {
    payload['user_id'] = this.props.user.id;
    payload['source'] = 'user';
    if (this.props.trade_type === 'PurchaseOrder') {
      const p = JSON.stringify({
        purchase_order: {buyer_contacts_attributes: [payload]},
      });
      this.props.dispatch(
        updatePurchaseOrder(
          this.props.trade_id,
          this.props.user.id,
          p,
          this.fetchTradeDocumentContacts,
          true,
        ),
      );
    } else if (this.props.trade_type === 'Invoice') {
      const p = JSON.stringify({
        invoice: {buyer_contacts_attributes: [payload]},
      });
      this.props.dispatch(
        updateInvoice(
          this.props.trade_id,
          this.props.user.id,
          p,
          this.fetchTradeDocumentContacts,
          true,
        ),
      );
    }

    if (this.shouldResolveNotification()) {
      this.props.resolveNotifications(this.props.fca_action);
    }
    onSuccess();
  };

  onUpdateContact = (id, payload, onSuccess, errorCallback) => {
    payload['id'] = id;
    if (this.props.trade_type === 'PurchaseOrder') {
      const p = JSON.stringify({
        purchase_order: {buyer_contacts_attributes: [payload]},
      });
      this.props.dispatch(
        updatePurchaseOrder(
          this.props.trade_id,
          this.props.user.id,
          p,
          this.fetchTradeDocumentContacts,
          true,
        ),
      );
    } else if (this.props.trade_type === 'Invoice') {
      const p = JSON.stringify({
        invoice: {buyer_contacts_attributes: [payload]},
      });
      this.props.dispatch(
        updateInvoice(
          this.props.trade_id,
          this.props.user.id,
          p,
          this.fetchTradeDocumentContacts,
          true,
        ),
      );
    }

    onSuccess();
  };

  onClickEditTradeContact = tradeContact => {
    return e => {
      const eventName =
        this.props.trade_type === 'PurchaseOrder'
          ? TrackEventName.PURCHASE_ORDER_CUSTOMER_CONTACT_EDIT_CLICKED
          : TrackEventName.INVOICE_CUSTOMER_CONTACT_EDIT_CLICKED;
      this.props.trackEvent(eventName);
      e.preventDefault();

      renderModal(
        <ContactContainerModal
          selectedContact={tradeContact}
          contacts={this.props.contacts}
          tradeContacts={this.state.trade_document_contacts}
          onAddContact={this.onCreateContact}
          onUpdateContact={this.onUpdateContact}
          onAddTradeContact={this.onAddContactToList}
          onDeleteContact={this.onDeleteContact}
          onClose={this.onCloseModal}
        />,
      );
    };
  };

  onClickAddContactButton = e => {
    const eventName =
      this.props.trade_type === 'PurchaseOrder'
        ? TrackEventName.PURCHASE_ORDER_CUSTOMER_CONTACT_ADD_CLICKED
        : TrackEventName.INVOICE_CUSTOMER_CONTACT_ADD_CLICKED;
    this.props.trackEvent(eventName);

    e.preventDefault();
    renderModal(
      <ContactContainerModal
        contacts={this.props.contacts}
        tradeContacts={this.props.trade_document_contacts}
        onAddContact={this.onCreateContact}
        onUpdateContact={this.onUpdateContact}
        onAddTradeContact={this.onAddContactToList}
        onDeleteContact={this.onDeleteContact}
        onClose={this.onCloseModal}
      />,
    );
  };

  renderTradeContacts() {
    if (
      this.props.trade_document_contacts.length === 0 ||
      this.props.trade_document_contacts.error
    )
      return <Empty />;

    return this.props.trade_document_contacts.map(tradeContact => {
      return (
        <TradeContact
          key={tradeContact.id}
          tradeContact={tradeContact}
          onClickEditTradeContact={this.onClickEditTradeContact}
          onDeleteContactFromList={this.onDeleteContactFromList}
        />
      );
    });
  }

  renderTradeContactsForm() {
    return (
      <Fragment>
        {this.renderTradeContacts()}
        {!this.props.hidden && (
          <section className="cardSection _simple _withColumns _noMinHeight --micro">
            <div className="text _noPadding _widthAuto">
              <p className="byline">
                Add contact person(s) in this transaction
              </p>
            </div>
            <button
              className="ds-btn --micro -success _widthAuto"
              data-testid="add-trade-contact"
              onClick={this.onClickAddContactButton}>
              {this.renderButtonText()}
            </button>
          </section>
        )}
      </Fragment>
    );
  }

  renderButtonText() {
    if (this.props.trade_document_contacts.length === 0) {
      return 'Add';
    } else {
      return 'Add Another';
    }
  }

  render() {
    return (
      <form key="content" className="ds-card">
        <section className="cardTitle"> Customer Contact Details </section>
        <section className="sectionList">
          {this.renderTradeContactsForm()}
        </section>
      </form>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.user,
    contacts: state.contacts.user_contacts,
    trade_document_contacts: state.contacts.trade_document_contacts,
    fca_action: ownProps.fca_action,
  };
};

export default connect(mapStateToProps, null, null, {withRef: true})(
  WholeContactsManagerContainer,
);



// WEBPACK FOOTER //
// ./src/features/contacts/containers/WholeContactsManagerContainer.js